module.exports = __webpack_public_path__ + "img/noodles-2.eb8979ea.jpg";